import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';

// This is done
const ProhibitedActivities = () => {
  return (
    <PrivacyPolicyContainer>
      <h4>Prohibited Activities</h4>
      <p>
        To maintain the integrity of our platform and services, users are
        prohibited from engaging in the following activities:
      </p>
      <ul>
        {/* General Prohibitions */}
        <li>
          Copying, distributing, modifying, or altering course materials without
          authorization.
        </li>
        <li>
          Sharing login credentials or granting access to unauthorized
          individuals.
        </li>
        <li>Using the platform for any unlawful or fraudulent activities.</li>

        {/* Specific Prohibitions */}
        <li>
          Sharing, reproducing, or distributing quiz questions or answers.
        </li>
        <li>Altering, falsifying, or misusing certificates of completion.</li>
        <li>
          Reselling or redistributing access to training portal content or
          courses.
        </li>
        <li>
          Using newsletters or promotional content for unauthorized purposes.
        </li>
        <li>
          Attempting to bypass or interfere with the platforms security
          features.
        </li>
      </ul>
      <p>
        Violations of these terms may result in the suspension or termination of
        your account and, where applicable, legal action.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default ProhibitedActivities;
